import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Tooltip } from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css';
// eslint-disable-next-line camelcase -- this is from 3rd-party library
import jwt_decode from 'jwt-decode';
import { setIsOpen } from '../../store/EnvironmentSetting/actions';

import './styles.scss';
import { selectDarkToggle } from '../../store/NavigationBar/selectors';
import logo from './sitelogo.png';
import useAuth from '../../hooks/useAuth';
import oidcConfig from '../../oidcConfig';
import { sendGAEvent } from '../../store/GoogleAnalytics/actions';
import {
  CLICK_LOGOUT_BUTTON,
  CLICK_EMBEDDING_SDK_DOCUMENTATION_LINK,
  CLICK_PLAYGROUND_USER_MANUAL_LINK,
} from '../../constants/google-analytics';

// Component containing the navigation bar with sign up options
const NavigationBar = ({ isDarkTheme, setIsPopUpOpen, onSendGAEvent }) => {
  const auth = useAuth();
  let decodedIdToken;
  if (oidcConfig.requireAuth && auth && auth.tokenResponse) {
    decodedIdToken = jwt_decode(auth.tokenResponse.idToken);
  }

  const onLogout = () => {
    onSendGAEvent(CLICK_LOGOUT_BUTTON);
    auth.signout();
  };

  return (
    <div className={isDarkTheme ? 'navigation-bar dark' : 'navigation-bar'}>
      <header>
        <div className={isDarkTheme ? 'menu dark' : 'menu'}>
          <div className="logo">
            <a href="https://www.microstrategy.com/en" target="_blank" rel="noreferrer">
              <img alt="" src={logo} />
            </a>
          </div>
          <div className="title">Embedding SDK Playground</div>

          <div
            className="icon-label-container your-dossier-container"
            onClick={() => setIsPopUpOpen(true)}
          >
            {/* <img className="your-dossier-icon" src={yourDossierIcon} alt="your dashboard icon" /> */}

            <svg
              className="your-dossier-icon"
              width="15"
              height="15"
              viewBox="0 0 15 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15 2C15 0.89543 14.1046 0 13 0H2C0.89543 0 0 0.89543 0 2V3C0 4.10457 0.89543 5 2 5H13C14.1046 5 15 4.10457 15 3V2ZM2 1H13C13.5523 1 14 1.44772 14 2V3C14 3.55228 13.5523 4 13 4H2C1.44772 4 1 3.55228 1 3V2C1 1.44772 1.44772 1 2 1ZM15 8C15 6.89543 14.1046 6 13 6H2C0.89543 6 0 6.89543 0 8V9C0 10.1046 0.89543 11 2 11H7V14H2V15H13V14H8V11H13C14.1046 11 15 10.1046 15 9V8ZM2 7H13C13.5523 7 14 7.44772 14 8V9C14 9.55228 13.5523 10 13 10H2C1.44772 10 1 9.55228 1 9V8C1 7.44772 1.44772 7 2 7ZM11.5 2.5C11.5 2.91421 11.1642 3.25 10.75 3.25C10.3358 3.25 10 2.91421 10 2.5C10 2.08579 10.3358 1.75 10.75 1.75C11.1642 1.75 11.5 2.08579 11.5 2.5ZM11.5 8.5C11.5 8.91421 11.1642 9.25 10.75 9.25C10.3358 9.25 10 8.91421 10 8.5C10 8.08579 10.3358 7.75 10.75 7.75C11.1642 7.75 11.5 8.08579 11.5 8.5Z"
                fill="#29313B"
              />
            </svg>

            <label className="label-your-dossier">Your Environment</label>
          </div>

          <div id="user-icon" className="icon-label-container" data-testid="user-icon">
            <svg
              className="user-icon"
              // viewBox="0 0 16.9 19.5"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.13294 6.56667C7.80821 6.56667 9.16628 5.2086 9.16628 3.53333C9.16628 1.85807 7.80821 0.5 6.13294 0.5C4.45768 0.5 3.09961 1.85807 3.09961 3.53333C3.09961 5.2086 4.45768 6.56667 6.13294 6.56667ZM6.13333 7.43266C8.20888 7.43266 10.19 8.30012 11.5977 9.82533C11.7032 9.94197 11.7632 10.0927 11.7667 10.25V12.85C11.7667 13.209 11.4757 13.5 11.1167 13.5H1.15C0.794372 13.5 0.504742 13.2143 0.5 12.8587V10.2587C0.501362 10.0984 0.561497 9.94421 0.669 9.82533C2.0767 8.30012 4.05779 7.43266 6.13333 7.43266Z"
              />
            </svg>
          </div>
          <Tooltip
            anchorId="user-icon"
            className="user-tooltip"
            place="bottom"
            delayHide={150}
            style={{ position: 'fixed' }}
            clickable
            // middlewares={[offset(10)]}
            content={
              <div>
                <div className="user-name-container">
                  {/* <img src={userIcon} alt="user avatar" /> */}
                  <div className="avatar">
                    {`${decodedIdToken?.given_name[0] ?? 'J'}${
                      decodedIdToken?.family_name[0] ?? 'D'
                    }`}
                  </div>
                  <label>{decodedIdToken?.name ?? 'John Doe'}</label>
                </div>
                <div
                  style={{
                    height: 0,
                    border: '0.5px solid rgb(201, 212, 223)',
                    margin: '10px 0px',
                  }}
                />
                <div className="user-menu-item">
                  <a
                    className="link-text"
                    href="https://github.com/MicroStrategy/playground"
                    target="_blank"
                    rel="noreferrer"
                    onClick={() => {
                      onSendGAEvent(CLICK_PLAYGROUND_USER_MANUAL_LINK);
                    }}
                  >
                    Playground User Manual
                  </a>
                </div>
                <div className="user-menu-item">
                  <a
                    className="link-text"
                    href="https://microstrategy.github.io/embedding-sdk-docs/"
                    target="_blank"
                    rel="noreferrer"
                    onClick={() => {
                      onSendGAEvent(CLICK_EMBEDDING_SDK_DOCUMENTATION_LINK);
                    }}
                  >
                    Embedding SDK Documentation
                  </a>
                </div>
                <div
                  style={{
                    height: 0,
                    border: '0.5px solid rgb(201, 212, 223)',
                    margin: '10px 0px',
                  }}
                />

                {oidcConfig.requireAuth && (
                  <div className="button-logout" onClick={onLogout}>
                    {/* <span className="material-icons">logout</span> */}
                    <div className="user-menu-item">Log Out</div>
                  </div>
                )}
              </div>
            }
          />

          {/* {oidcConfig.requireAuth && (
            <div className="button-logout" onClick={onLogout}>
              <span className="material-icons">logout</span>
              Logout
            </div>
          )} */}
        </div>
      </header>
    </div>
  );
};

NavigationBar.propTypes = {
  isDarkTheme: PropTypes.bool.isRequired,
  setIsPopUpOpen: PropTypes.func.isRequired,
  onSendGAEvent: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
  return {
    isDarkTheme: selectDarkToggle(state),
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      setIsPopUpOpen: setIsOpen,
      onSendGAEvent: sendGAEvent,
    },
    dispatch,
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(NavigationBar);
